var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.968099C12.7498 0.968099 13.4163 1.14265 13.8867 1.41146C14.3641 1.6843 14.5938 2.02282 14.5938 2.3431C14.5938 2.66338 14.3641 3.0019 13.8867 3.27474C13.4163 3.54355 12.7498 3.7181 12 3.7181C11.2502 3.7181 10.5837 3.54355 10.1133 3.27474C9.63586 3.0019 9.40625 2.66338 9.40625 2.3431C9.40625 2.02282 9.63586 1.6843 10.1133 1.41146C10.5837 1.14265 11.2502 0.968099 12 0.968099Z",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42709 2.3431V3.71419M9.42709 3.71419L10.8287 5.75289C10.886 5.83624 10.9167 5.93501 10.9167 6.03615V20.6396M9.42709 3.71419C10.3739 5.09135 13.5036 5.26951 14.5729 3.71419M10.9167 20.6396L11.8537 22.943C11.9042 23.0673 12.08 23.0678 12.1313 22.9438L13.0833 20.6396M10.9167 20.6396C11.9916 21.2168 11.9916 21.2168 13.0833 20.6396M14.5729 3.71419L13.1713 5.75289C13.114 5.83624 13.0833 5.93501 13.0833 6.03615V20.6396M14.5729 3.71419V2.3431",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/Golf.cd8026e2b4febf0e7cbb256af868765a.svg";
export { ForwardRef as ReactComponent };